import React, {
  useEffect,
  useContext,
  useRef,
  Fragment,
  useState,
  use,
} from "react";
import { AppContext } from "../context";
import {
  addImageToList,
  setLog,
  userLogs,
  patLogs,
  translateText,
  setKotakRecapMenuSection,
  getConstraint,
  getAspectRatioClientList,
  setGlobalImageQueue,
  setCameraOpenFlag,
  getCameraOpenFlag,
  imageFeedbackLambda,
  getVinFeedback,
  getDocumentTagIndex,
  getWebpImageFormat,
  getImgQualityFactor,
  getNewConfirmBtn
} from "../context/utils";
import cameraImg from "../img/camera.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Rotate from "./Rotate";
import VINImg from "../img/VINPopup.png";
import car_inspection from "../img/vin.png";
import { Check } from "lucide-react";
import dashboard from "../img/dashboard.jpg";
import { startVideoPlayback } from "../utils_new/videoPlayback";
import SafeImage from "./SafeImage";
// import image1 from "../img/odometer1.jpg";
// import ReactGA from "react-ga4";

const screenfull = require("screenfull");
let imageCaptured = false;
let image = {};
// let cameraStarted = false;
let track = null;
let imgUrl = null;
let logBugs = true;
let videoEl;
let vinCapturedCount = 0;
let checkVin = [];
let timeout = null;
let vinEditToastId = null;

let engineCapturedCount = 0;
let checkEngine = null;

// Crate capture guide outlines, traced from real crate photos. Each viewBox is
// sized to that face's real proportions so the white outline matches the
// crate the user is framing. Only used when "single-image".crate_stencil is on.
const CRATE_END_FACE = { viewBox: "0 0 74 100", paths: ["M0 0 H74 V100 H0 Z"] };
const CRATE_SIDE_FACE = { viewBox: "0 0 184 100", paths: ["M0 0 H184 V100 H0 Z"] };
const CRATE_STENCILS = {
  "front view": CRATE_END_FACE,
  "rear view": CRATE_END_FACE,
  "left view": CRATE_SIDE_FACE,
  "right view": CRATE_SIDE_FACE,
  // 3D top view: lid seen in perspective (narrowing away from the camera)
  // sitting on top of the near end face.
  "top view": {
    viewBox: "0 0 615 790",
    paths: ["M195 0 H420 L615 490 H0 Z", "M0 490 H615 V790 H0 Z"],
  },
};

const SingleImage = () => {
  const {
    inspectionId,
    clientId,
    stepCovered,
    setStepCovered,
    condition,
    config,
    currentBlock,
    setCurrentPage,
    setCondition,
    setScreen,
    mandatory,
    setMandatory,
    isLandscape,
    setLandscape,
    isIOS,
  } = useContext(AppContext);
  let webCamPromise = null;

  //Reference vaiables
  const singleScreen = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const cameraRequestInFlightRef = useRef(false);
  const resizeDebounceRef = useRef(null);
  const startBtn = useRef();
  const imgRef = useRef();
  const backRef = useRef();
  const divImgRef = useRef();
  const guidanceTextRef = useRef();
  const redLineVINcontainer = useRef();
  const crateStencilRef = useRef();
  const cardRef = useRef();
  const cardDashboardRef = useRef();
  const cardDashboardRef1 = useRef();
  const feedBackPopUp = useRef();
  const crossTickBtn = useRef();
  const feedBackPopText = useRef();
  const carInspectionRef = useRef();
  const headerText1 = useRef();
  const feedbackBtnRef = useRef();
  const vinInputRef = useRef();
  // const headerText2 = useRef();
  const imageRef = useRef();
  const feedbackSuccessTopPopRef = useRef();
  const feedbackSuccessBottomPopRef = useRef();
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [feedbackBtnText, setFeedbackBtnText] = useState("");
  const [isStreamRotated, setIsStreamRotated] = useState(false);

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  const isInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  if (logBugs) {
    patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
    userLogs({
      position: 8,
      last_page: `${currentBlock.tag} Module`,
      inspectionId,
    });
  }
  logBugs = false;

  // The captured-image preview covers the whole viewport, so the live-camera
  // guidance (tag label, white box, guidance text) must never be left showing
  // on top of it. Every path that reveals the preview goes through here.
  const showCapturedPreview = () => {
    if (redLineVINcontainer.current)
      redLineVINcontainer.current.style.display = "none";
    if (crateStencilRef.current) crateStencilRef.current.style.display = "none";
    if (imgRef.current) imgRef.current.style.display = "block";
  };

  // Outline for the current crate view, or null when this block is not a
  // crate view or the client has not switched crate stencils on.
  const crateStencil =
    config["single-image"] &&
    config["single-image"]["crate_stencil"] &&
    typeof currentBlock["tag"] === "string"
      ? CRATE_STENCILS[currentBlock["tag"].trim().toLowerCase()] || null
      : null;

  const showCrateStencil = () => {
    if (crateStencilRef.current) crateStencilRef.current.style.display = "flex";
  };

  const isCapturedPreviewOpen = () =>
    !!imgRef.current && imgRef.current.style.display === "block";

  // Drops the previous block's capture so it can never be shown as this
  // block's image. imgUrl/image are module level and outlive the component.
  const resetCapturedPreview = () => {
    imgUrl = null;
    imageCaptured = false;
    if (imgRef.current) imgRef.current.style.display = "none";
    if (divImgRef.current) divImgRef.current.removeAttribute("src");
  };

  // VIN plates and odometer readings are small text the user holds the phone
  // close to, so the wide-angle 0.5 zoom the shared constraint defaults to
  // makes them unreadable. Force 1x for those two blocks only.
  const getCameraConstraint = () => {
    const constraints = getConstraint(config, clientId);
    if (["VIN", "Odometer"].includes(currentBlock["tag"])) {
      constraints.video.zoom = { ideal: 1 };
    }
    return constraints;
  };

  const startCamera = () => {
    try {
      const guardInFlight = isIOS;
      if (guardInFlight) {
        if (cameraRequestInFlightRef.current) return;
        cameraRequestInFlightRef.current = true;
      }
      if (timeout) clearTimeout(timeout);

      webCamPromise = navigator.mediaDevices
        .getUserMedia(getCameraConstraint())
        .then((stream) => {
          if (window.stream) {
            window.stream.getTracks().forEach((track) => track.stop());
            window.stream = null;
          }

          window.stream = stream;
          track = stream.getTracks()[0];
          videoEl = videoRef.current;

          if (videoEl) {
            videoEl.srcObject = stream;
            startVideoPlayback(videoEl, config);

            videoEl.onloadedmetadata = () => {
              const isRotated =
                videoEl.videoWidth < videoEl.videoHeight &&
                window.innerWidth > window.innerHeight;
              setIsStreamRotated(isRotated);
              feedBackPopText.current.innerHTML = getTranslateText(
                "Hang tight! We’re analyzing your image — this will only take a few seconds.",
              );

              if (imgUrl) {
                divImgRef.current.src = imgUrl;
                showCapturedPreview();
                if (
                  currentBlock["tag"] === "Engine" ||
                  currentBlock["tag"] === "RC"
                ) {
                  if (carInspectionRef.current)
                    carInspectionRef.current.style.display = "none";
                  if (!checkEngine || typeof checkEngine.engine !== "boolean") {
                    feedBackPopText.current.innerHTML = getTranslateText(
                      "Unable to validate the image. Please capture again.",
                    );
                    feedbackBtnRef.current.style.display = "flex";
                    setFeedbackBtnText(getTranslateText("Recapture image"));
                    return;
                  }

                  // ✅ TRUE means it is engine image
                  if (checkEngine.engine) {
                    feedBackPopUp.current.style.display = "none";

                    feedbackSuccessTopPopRef.current.style.display = "flex";
                    // feedbackSuccessBottomPopRef.current.style.display = "none";0

                    setFeedbackBtnText(getTranslateText("Proceed"));

                    timeout = setTimeout(() => {
                      feedbackSuccessTopPopRef.current.style.display = "none";
                      imageNext();
                    }, 3000);
                  } else {
                    // ❌ FALSE means not engine image
                    feedBackPopText.current.innerHTML = getTranslateText(
                      currentBlock["tag"] === "RC"
                        ? "It looks like this is not an document image. Please capture again."
                        : "It looks like this is not an Engine image. Please capture again.",
                    );

                    feedbackBtnRef.current.style.display = "flex";
                    setFeedbackBtnText(getTranslateText("Recapture image"));
                  }
                }
                // VIN feedback UI handling on reload
                if (
                  getVinFeedback() &&
                  ![
                    "client_1511",
                    "client_1298",
                    "client_1298_prod",
                    "client_1298_dev",
                  ].includes(clientId) &&
                  currentBlock["tag"] === "VIN" &&
                  vinCapturedCount === 1
                ) {
                  if (checkVin.length === 0) {
                    feedBackPopText.current.innerHTML = getTranslateText(
                      "Hang tight! We’re analyzing your image — this will only take a few seconds.",
                    );
                  } else if (!checkVin[1]) {
                    feedBackPopUp.current.style.display = "flex";
                    feedbackBtnRef.current.style.display = "flex";
                    carInspectionRef.current.style.width = "10dvw";

                    if (["image captured is not VIN"].includes(checkVin[0])) {
                      feedBackPopText.current.innerHTML = getTranslateText(
                        "It looks like the image doesn’t contain a #. Please try capturing it again.",
                      ).replace("#", currentBlock["id"]);
                    } else if (
                      ["The chassis no is not clearly visible"].includes(
                        checkVin[0],
                      )
                    ) {
                      feedBackPopText.current.innerHTML = getTranslateText(
                        "The # isn’t clearly visible. Please try capturing the image again.",
                      ).replace("#", currentBlock["id"]);
                    }
                  } else if (checkVin[1]) {
                    if (feedBackPopUp.current)
                      feedBackPopUp.current.style.display = "none";
                    if (feedbackSuccessTopPopRef.current)
                      feedbackSuccessTopPopRef.current.style.display = "flex";
                    if (feedbackSuccessBottomPopRef.current)
                      feedbackSuccessBottomPopRef.current.style.display =
                        "flex";
                    setFeedbackBtnText(getTranslateText("Proceed"));

                    if (
                      !(
                        Object.keys(config).includes("allowVinFeedbackEdit") &&
                        config["allowVinFeedbackEdit"]
                      )
                    ) {
                      timeout = setTimeout(() => {
                        feedbackSuccessTopPopRef.current.style.display = "none";
                        feedbackSuccessBottomPopRef.current.style.display =
                          "none";
                        imageNext();
                      }, 4000);
                    }
                  }

                  crossTickBtn.current.style.display = "none";
                }
              } else setWhiteBlock();

              if (currentBlock["tag"] === "VIN") {
                if (
                  !Object.keys(config["single-image"]).includes("vin_popup") &&
                  !config["single-image"]["vin_popup"]
                ) {
                  setTimeout(() => {
                    if (startBtn.current)
                      startBtn.current.style.display = "block";
                  }, 300);
                }
              } else {
                setTimeout(() => {
                  if (startBtn.current)
                    startBtn.current.style.display = "block";
                }, 500);
              }

              setCameraOpenFlag(true);
            };
          } else {
            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                startVideoPlayback(videoRef.current, config);

                videoRef.current.onloadedmetadata = () => {
                  const currentVideoEl = videoRef.current;
                  const isRotated =
                    currentVideoEl.videoWidth < currentVideoEl.videoHeight &&
                    window.innerWidth > window.innerHeight;
                  setIsStreamRotated(isRotated);
                  feedBackPopText.current.innerHTML = getTranslateText(
                    "Hang tight! We’re analyzing your image — this will only take a few seconds.",
                  );

                  if (imgUrl) {
                    divImgRef.current.src = imgUrl;
                    showCapturedPreview();

                    if (
                      getVinFeedback() &&
                      ![
                        "client_1511",
                        "client_1298",
                        "client_1298_prod",
                        "client_1298_dev",
                      ].includes(clientId) &&
                      currentBlock["tag"] === "VIN" &&
                      vinCapturedCount === 1
                    ) {
                      if (checkVin.length === 0) {
                        feedBackPopText.current.innerHTML = getTranslateText(
                          "Hang tight! We’re analyzing your image — this will only take a few seconds.",
                        );
                      } else if (!checkVin[1]) {
                        feedBackPopUp.current.style.display = "flex";
                        feedbackBtnRef.current.style.display = "flex";
                        carInspectionRef.current.style.width = "10dvw";

                        if (
                          ["image captured is not VIN"].includes(checkVin[0])
                        ) {
                          feedBackPopText.current.innerHTML = getTranslateText(
                            "It looks like the image doesn’t contain a #. Please try capturing it again.",
                          ).replace("#", currentBlock["id"]);
                        } else if (
                          ["The chassis no is not clearly visible"].includes(
                            checkVin[0],
                          )
                        ) {
                          feedBackPopText.current.innerHTML = getTranslateText(
                            "The # isn’t clearly visible. Please try capturing the image again.",
                          ).replace("#", currentBlock["id"]);
                        }
                      } else if (checkVin[1]) {
                        if (feedBackPopUp.current)
                          feedBackPopUp.current.style.display = "none";
                        if (feedbackSuccessTopPopRef.current)
                          feedbackSuccessTopPopRef.current.style.display =
                            "flex";
                        if (feedbackSuccessBottomPopRef.current)
                          feedbackSuccessBottomPopRef.current.style.display =
                            "flex";
                        setFeedbackBtnText(getTranslateText("Proceed"));

                        if (
                          !(
                            Object.keys(config).includes(
                              "allowVinFeedbackEdit",
                            ) && config["allowVinFeedbackEdit"]
                          )
                        ) {
                          timeout = setTimeout(() => {
                            feedbackSuccessTopPopRef.current.style.display =
                              "none";
                            feedbackSuccessBottomPopRef.current.style.display =
                              "none";
                            imageNext();
                          }, 4000);
                        }
                      }

                      crossTickBtn.current.style.display = "none";
                    }
                  } else setWhiteBlock();

                  setCameraOpenFlag(true);

                  if (currentBlock["tag"] === "VIN") {
                    if (
                      !Object.keys(config["single-image"]).includes(
                        "vin_popup",
                      ) &&
                      !config["single-image"]["vin_popup"]
                    ) {
                      setTimeout(() => {
                        if (startBtn.current)
                          startBtn.current.style.display = "block";
                      }, 500);
                    }
                  } else {
                    setTimeout(() => {
                      if (startBtn.current)
                        startBtn.current.style.display = "block";
                    }, 500);
                  }
                };
              }
            }, 200);
          }
        })
        .finally(() => {
          if (guardInFlight) cameraRequestInFlightRef.current = false;
        });
    } catch (error) {
      // console.log(error);
      if (isIOS) cameraRequestInFlightRef.current = false;
    }
  };
  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const captureImg = () => {
    //patLogs("Image capture button clicked", inspectionId);
    const cnv = canvasRef.current;
    const vw = videoRef.current;
    if (isStreamRotated) {
      cnv.width = vw.videoHeight;
      cnv.height = vw.videoWidth;
      const ctx = cnv.getContext("2d");
      ctx.translate(cnv.width / 2, cnv.height / 2);
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
    } else {
      cnv.width = vw.videoWidth;
      cnv.height = vw.videoHeight;
      cnv.getContext("2d").drawImage(vw, 0, 0);
    }
    const imgData =
      getWebpImageFormat() && !isIOS
        ? cnv.toDataURL("image/webp", getImgQualityFactor())
        : cnv.toDataURL("image/jpeg");
    imgUrl = imgData;
    divImgRef.current.src = imgData;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    image = {
      name: Array.isArray(currentBlock["tag"])
        ? `${getDocumentTagIndex()}.jpg`
        : `${currentBlock["tag"]}.jpg`,
      imgData: imgData,
      tag: Array.isArray(currentBlock["tag"])
        ? getDocumentTagIndex()
        : currentBlock["tag"],
      web_region: null,
      angle: null,
      region: region,
      videoData: null,
      dialStatus: null,
      currentBlockName: currentBlock["id"],
    };
    if (
      ["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(
        currentBlock["tag"],
      )
    )
      redLineVINcontainer.current.style.display = "none";
    if (currentBlock["tag"] === "VIN") {
      image["vinFeedback"] = [
        "client_1511",
        "client_1298",
        "client_1298_prod",
        "client_1298_dev",
      ].includes(clientId)
        ? false
        : getVinFeedback();
      if (vinCapturedCount !== 0) image["vinNumber"] = "";
    }
    showCapturedPreview();
    if (currentBlock["tag"] === "Engine" || currentBlock["tag"] === "RC") {
      image["engineFeedback"] = true;
    }
  };

  const imageRetake = () => {
    setStepCovered([...stepCovered]);
    setMessage("");
    // patLogs("retake button clicked for capture new image again", inspectionId);
    imgUrl = null;
    if (
      ["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(
        currentBlock["tag"],
      )
    )
      redLineVINcontainer.current.style.display = "flex";
    showCrateStencil();
    imgRef.current.style.display = "none";
  };

  const vinCheckingHanlder = async () => {
    vinCapturedCount++;
    crossTickBtn.current.style.display = "none";
    feedBackPopUp.current.style.display = "flex";
    checkVin = await imageFeedbackLambda({
      inspection_id: inspectionId,
      image:
        getWebpImageFormat() && !isIOS
          ? image["imgData"].replace(/^data:image\/webp;base64,/, "")
          : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
      tag: currentBlock["tag"],
      Vin_feedback: true,
      client_id: clientId,
      type: "vin",
      region: image["region"],
    });
    let feedbackRes = {
      result: checkVin,
      region: image["region"],
    };
    //// console.log("vin feedback response :::: ", checkVin);
    if (checkVin && checkVin[0])
      patLogs(`VIN Feedback: ${checkVin[0]}`, inspectionId);
    else patLogs(`VIN Feedback: ${JSON.stringify(feedbackRes)}`, inspectionId);
    setMessage(checkVin[0]);
    carInspectionRef.current.style.width = "10dvw";
    if (checkVin && checkVin[1]) {
      // Handle the case where VIN check success and allow the user to submit
      feedBackPopUp.current.style.display = "none";
      feedbackSuccessTopPopRef.current.style.display = "flex";
      if (
        !(
          Object.keys(config).includes("allowVinFeedbackEdit") &&
          config["allowVinFeedbackEdit"]
        )
      )
        feedbackSuccessBottomPopRef.current.style.display = "none";
      else feedbackSuccessBottomPopRef.current.style.display = "flex";
      setFeedbackBtnText(getTranslateText("Proceed"));
      if (
        !(
          Object.keys(config).includes("allowVinFeedbackEdit") &&
          config["allowVinFeedbackEdit"]
        )
      ) {
        timeout = setTimeout(() => {
          feedbackSuccessTopPopRef.current.style.display = "none";
          // feedbackSuccessBottomPopRef.current.style.display = "none";
          imageNext();
        }, 4000);
      }
    } else {
      // Handle the case where VIN check fails and allow user to recapture
      feedbackBtnRef.current.style.display = "flex";
      setFeedbackBtnText(getTranslateText("Recapture image"));
      if (["image captured is not VIN"].includes(checkVin[0])) {
        feedBackPopText.current.innerHTML = getTranslateText(
          "It looks like the image doesn’t contain a #. Please try capturing it again.",
        ).replace("#", currentBlock["id"]);
      } else if (
        ["The chassis no is not clearly visible"].includes(checkVin[0])
      ) {
        feedBackPopText.current.innerHTML = getTranslateText(
          "The # isn’t clearly visible. Please try capturing the image again.",
        ).replace("#", currentBlock["id"]);
      } else
        feedBackPopText.current.innerHTML = getTranslateText(
          "The # isn’t clearly visible. Please try capturing the image again.",
        ).replace("#", currentBlock["id"]);
    }
  };

  useEffect(() => {
    if (
      (currentBlock["tag"] === "Engine" || currentBlock["tag"] === "RC") &&
      isLandscape
    ) {
      if (checkEngine !== null && Object.keys(checkEngine).length === 0) {
        if (carInspectionRef.current)
          carInspectionRef.current.style.display = "none";
        if (crossTickBtn.current) crossTickBtn.current.style.display = "none";
        if (feedBackPopUp.current) feedBackPopUp.current.style.display = "flex";
        if (feedbackBtnRef.current)
          feedbackBtnRef.current.style.display = "none";

        if (feedBackPopText.current)
          feedBackPopText.current.innerHTML = getTranslateText(
            "Hang tight! We’re analyzing your image — this will only take a few seconds.",
          );

        if (!checkEngine || typeof checkEngine.engine !== "boolean") {
          if (feedBackPopText.current)
            feedBackPopText.current.innerHTML = getTranslateText(
              "Unable to validate the image. Please capture again.",
            );
          if (feedbackBtnRef.current)
            feedbackBtnRef.current.style.display = "flex";
          setFeedbackBtnText(getTranslateText("Recapture image"));
          return;
        }

        // ✅ TRUE means it is engine image
        if (checkEngine.engine) {
          if (feedBackPopUp.current)
            feedBackPopUp.current.style.display = "none";

          if (feedbackSuccessTopPopRef.current)
            feedbackSuccessTopPopRef.current.style.display = "flex";

          // feedbackSuccessBottomPopRef.current.style.display = "none";

          setFeedbackBtnText(getTranslateText("Proceed"));

          timeout = setTimeout(() => {
            if (feedbackSuccessTopPopRef.current)
              feedbackSuccessTopPopRef.current.style.display = "none";
            imageNext();
          }, 3000);
        } else {
          // ❌ FALSE means not engine image
          if (feedBackPopText.current)
            feedBackPopText.current.innerHTML = getTranslateText(
              currentBlock["tag"] === "RC"
                ? "It looks like this is not an document image. Please capture again."
                : "It looks like this is not an Engine image. Please capture again.",
            );

          if (feedbackBtnRef.current)
            feedbackBtnRef.current.style.display = "flex";

          setFeedbackBtnText(getTranslateText("Recapture image"));
        }
      }
    }
  }, [isLandscape]);

  const engineCheckingHandler = async () => {
    if (carInspectionRef.current)
      carInspectionRef.current.style.display = "none";
    engineCapturedCount++;
    crossTickBtn.current.style.display = "none";
    feedBackPopUp.current.style.display = "flex";
    feedbackBtnRef.current.style.display = "none";

    feedBackPopText.current.innerHTML = getTranslateText(
      "Hang tight! We’re analyzing your image — this will only take a few seconds.",
    );

    checkEngine = await imageFeedbackLambda({
      inspection_id: inspectionId,
      image:
        getWebpImageFormat() && !isIOS
          ? image["imgData"].replace(/^data:image\/webp;base64,/, "")
          : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
      tag: currentBlock["tag"] === "RC" ? "document" : "engine",
      client_id: clientId,
      type: currentBlock["tag"] === "RC" ? "document" : "engine",
      region: image["region"],
    });
    if (checkEngine && checkEngine.document_quality !== undefined) {
      checkEngine["engine"] = checkEngine["document_quality"];
    }

    patLogs(
      `ENGINE Feedback Response: ${JSON.stringify(checkEngine)}`,
      inspectionId,
    );

    if (!checkEngine || typeof checkEngine.engine !== "boolean") {
      feedBackPopText.current.innerHTML = getTranslateText(
        "Unable to validate the image. Please capture again.",
      );
      feedbackBtnRef.current.style.display = "flex";
      setFeedbackBtnText(getTranslateText("Recapture image"));
      return;
    }

    // ✅ TRUE means it is engine image
    if (checkEngine.engine) {
      feedBackPopUp.current.style.display = "none";

      feedbackSuccessTopPopRef.current.style.display = "flex";

      // feedbackSuccessBottomPopRef.current.style.display = "none";

      setFeedbackBtnText(getTranslateText("Proceed"));

      timeout = setTimeout(() => {
        feedbackSuccessTopPopRef.current.style.display = "none";
        imageNext();
      }, 3000);
    } else {
      // ❌ FALSE means not engine image
      feedBackPopText.current.innerHTML = getTranslateText(
        currentBlock["tag"] === "RC"
          ? "It looks like this is not an document image. Please capture again."
          : "It looks like this is not an Engine image. Please capture again.",
      );

      feedbackBtnRef.current.style.display = "flex";

      setFeedbackBtnText(getTranslateText("Recapture image"));
    }
  };

  const imageNext = () => {
    setGlobalImageQueue(image);
    logBugs = true;
    if (imageCaptured) return;
    patLogs(
      `tick button clicked and image is sent for uploading , ${currentBlock["tag"]} module is completed`,
      inspectionId,
    );
    // cameraStarted = false;
    setCameraOpenFlag(false);
    imageCaptured = true;
    if (currentBlock["mandatory"]) {
      let temp1 = mandatory;
      temp1[currentBlock["id"]] = "completed";
      setMandatory(temp1);
    }
    let temp = condition;
    temp[currentBlock["id"]] = "completed";
    setKotakRecapMenuSection(currentBlock["tag"]);
    setCondition(temp);
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
    setLog(`${currentBlock["tag"]} was captured`);
    // add image here for sending
    image["vinNumber"] = message;
    addImageToList(image);
    window.stream = null;
    track.stop();
    imgUrl = null;
  };

  const back = () => {
    logBugs = true;
    patLogs("back button clicked", inspectionId);
    window.stream = null;
    track.stop();
    // Leaving without confirming still discards the capture — otherwise the
    // next block inherits it. imageNext/imageRetake already do the same.
    resetCapturedPreview();
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
    // cameraStarted = false;
    setCameraOpenFlag(false);
  };

  const handleVinChange = (e) => {
    let value = e.target.value;

    // 1️⃣ Allow only alphabets and numbers (remove special characters)
    value = value.replace(/[^a-zA-Z0-9]/g, "");

    // 2️⃣ Check if length exceeds 17 characters
    if (value.length > 17) {
      // Only show toast if not already showing
      if (!vinEditToastId || !toast.isActive(vinEditToastId)) {
        vinEditToastId = toast.error(
          getTranslateText("You can enter up to 17 characters"),
          {
            position: "bottom-right",
            theme: "colored",
          },
        );
      }
      return; // stop updating state
    }
    setMessage(value?.toUpperCase());
  };
  const formatVinForDisplay = (rawVin) => {
    return rawVin?.toUpperCase();
  };

  const setWhiteBlock = () => {
    setTimeout(() => {
      // A capture can complete while this is pending — the guidance must never
      // be raised back over an image the user is already reviewing.
      if (isCapturedPreviewOpen()) return;
      showCrateStencil();
      if (
        ["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(
          currentBlock["tag"],
        )
      ) {
        if (
          currentBlock["tag"] === "VIN" &&
          Object.keys(config["single-image"]).includes("vin_popup") &&
          config["single-image"]["vin_popup"]
        )
          cardRef.current.style.display = "flex";
        else {
          if (
            !(
              (Object.keys(config["single-image"]).includes(
                "instruction1_tag",
              ) ||
                Object.keys(config["single-image"]).includes(
                  "instruction2_tag",
                )) &&
              [
                config["single-image"]["instruction2_tag"]
                  ? config["single-image"]["instruction2_tag"]
                  : "",
                config["single-image"]["instruction1_tag"]
                  ? config["single-image"]["instruction1_tag"]
                  : "",
              ].includes(currentBlock["tag"])
            )
          )
            redLineVINcontainer.current.style.display = "flex";
        }
        switch (currentBlock["tag"]) {
          case "VIN":
            if (config["single-image"]["guidance-text"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box",
              );
            break;
          case "Odometer":
            if (config["single-image"]["guidance-text-odo"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-odo"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box",
              );
            break;
          case "Open Trunk":
            if (config["single-image"]["guidance-text-trunk"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-trunk"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box",
              );
            break;
          case "Gear Shift":
            if (config["single-image"]["guidance-text-gear"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-gear"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box",
              );
            break;
          default:
            guidanceTextRef.current.innerHTML = getTranslateText(
              "Please position inside the white-bordered box",
            );
        }
      }
    }, 1000);
  };

  useEffect(() => {
    // whenever editing is enabled, scroll the input into view after render
    if (isEditing && vinInputRef.current) {
      setTimeout(() => {
        vinInputRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        vinInputRef.current.focus();
      }, 300); // small delay ensures keyboard is visible
    }
  }, [isEditing]);

  useEffect(() => {
    // Clear the previous block's capture BEFORE the camera starts. These are
    // module-level and survive the component, so a block entered right after a
    // capture (Odometer straight after VIN) would otherwise have the camera
    // callback find that stale image and raise its preview over the viewfinder.
    vinCapturedCount = 0;
    checkVin = [];
    engineCapturedCount = 0;
    checkEngine = null;
    resetCapturedPreview();

    if (
      Object.keys(config["single-image"]).includes("instruction1_tag") &&
      [config["single-image"]["instruction1_tag"]].includes(currentBlock["tag"])
    )
      cardDashboardRef.current.style.display = "flex";
    if (
      Object.keys(config["single-image"]).includes("instruction2_tag") &&
      [config["single-image"]["instruction2_tag"]].includes(currentBlock["tag"])
    )
      cardDashboardRef1.current.style.display = "flex";
    startCamera();
    setLandscape(land());
    setFeedbackBtnText(getTranslateText("Recapture image"));
    setWhiteBlock();
    setMessage("");
    feedBackPopText.current.innerHTML = getTranslateText(
      "Hang tight! We’re analyzing your image — this will only take a few seconds.",
    );
  }, []);

  useEffect(() => {
    const checkOrientation = () => {
      const isL = land();
      setLandscape(isL);
      if (!isL) {
        if (isIOS && window.stream) {
          window.stream.getTracks().forEach((t) => t.stop());
          window.stream = null;
          track = null;
        }
        setCameraOpenFlag(false);
        setIsStreamRotated(false);
      } else {
        if (!getCameraOpenFlag()) {
          // iOS needs a longer cooldown for the previous capture
          // session to fully release before requesting a new one, otherwise
          // repeated rotations can leave the stream stuck at stale metadata
          const restartDelay = isIOS ? 300 : 100;
          setTimeout(() => startCamera(), restartDelay);
        } else {
          const videoEl = videoRef.current;
          if (videoEl) {
            const isRotated =
              videoEl.videoWidth < videoEl.videoHeight &&
              window.innerWidth > window.innerHeight;
            setIsStreamRotated(isRotated);
          }
        }
      }
    };
    const handleResize = () => {
      if (isIOS) {
        // collapse the burst of resize events fired mid-rotation on iOS
        // into a single check once the orientation settles
        if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
        resizeDebounceRef.current = setTimeout(checkOrientation, 200);
      } else {
        checkOrientation();
      }
    };
    // Menu/Instructions and friends assign window.onresize during render and
    // never clear it on unmount. That stale handler calls setLandscape()
    // undebounced, which would flip orientation mid-rotation and defeat the
    // debounce above. Park it while this view owns the screen.
    const previousOnResize = window.onresize;
    window.onresize = null;

    window.addEventListener("resize", handleResize);
    return () => {
      window.onresize = previousOnResize;
      window.removeEventListener("resize", handleResize);
      if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
      if (window.stream) {
        window.stream.getTracks().forEach((track) => track.stop());
        window.stream = null;
      }
    };
  }, []);

  return (
    <Fragment>
      {!isLandscape ? (
        <Rotate />
      ) : (
        <div
          id="vin-screen"
          ref={singleScreen}
          style={{
            height: ["porto_seguros", "client_1422_claim"].includes(clientId) ? "90dvh" : "100dvh",
            overflowY: "auto",
          }}
        >
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>
          <video
            ref={videoRef}
            id="videoWindow"
            style={
              isStreamRotated
                ? {
                  width: "100vh",
                  height: "100vw",
                  objectFit: getAspectRatioClientList(clientId, config)
                    ? "contain"
                    : "cover",
                  backgroundColor: "black",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%) rotate(90deg)",
                }
                : getAspectRatioClientList(clientId, config)
                  ? {
                    width: "100vw",
                    height: "100vh",
                    objectFit: "contain",
                    backgroundColor: "black",
                  }
                  : {}
            }
            autoPlay
            playsInline
          ></video>
          <div ref={cardDashboardRef} id="display-card-dashboard">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                paddingTop: "2%",
              }}
            >
              <div
                id="image-container"
                style={{ width: "unset", paddingLeft: "2%" }}
              >
                <img
                  style={{
                    width: "45dvw",
                    borderRadius: "5%",
                    height: "60dvh",
                  }}
                  src={dashboard}
                ></img>
              </div>
              <div id="dashboard-points">
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst",
                    )
                      ? config["single-image"]["document-inst"]["inst-One"]
                      : getTranslateText(
                        "Photo of the interior of the vehicle that must show the steering wheel, radio, and glove compartment.",
                      )}
                  </p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst",
                    )
                      ? config["single-image"]["document-inst"]["inst-Two"]
                      : getTranslateText(
                        "To get a good photo, we recommend taking it from the back seat, between the headrests of the front seats, so the entire dashboard is visible.",
                      )}
                  </p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst",
                    )
                      ? config["single-image"]["document-inst"]["inst-Three"]
                      : getTranslateText(
                        "The photo will be considered incorrect if it is cut off at any point or if an object prevents the dashboard from being seen completely.",
                      )}
                  </p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "var(--btn-text, #fff)",
                  width: "20%",
                  height: "100%",
                  borderRadius: "10px",
                  border: "none",
                }}
                onClick={() => {
                  cardDashboardRef.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>
          <div ref={cardDashboardRef1} id="display-card-dashboard">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                paddingTop: "2%",
              }}
            >
              <div
                id="image-container"
                style={{ width: "unset", paddingLeft: "2%" }}
              >
                <SafeImage
                  style={{
                    width: "45dvw",
                    borderRadius: "5%",
                    height: "60dvh",
                  }}
                  src={
                    Object.keys(config["single-image"]).includes(
                      "document-inst1_img",
                    )
                      ? config["single-image"]["document-inst1_img"]
                      : "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/odometerInstruction.jpg"
                  } />
              </div>
              <div id="dashboard-points">
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst1",
                    )
                      ? config["single-image"]["document-inst1"]["inst-One"]
                      : getTranslateText(
                        "Start the vehicle and keep the engine idling (RPM at 0).",
                      )}
                  </p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst1",
                    )
                      ? config["single-image"]["document-inst1"]["inst-Two"]
                      : getTranslateText(
                        "Ensure the total mileage (odometer reading) is clearly visible.",
                      )}
                  </p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                    {Object.keys(config["single-image"]).includes(
                      "document-inst1",
                    )
                      ? config["single-image"]["document-inst1"]["inst-Three"]
                      : getTranslateText(
                        "Capture the complete instrument panel, including the speedometer and tachometer.",
                      )}
                  </p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "var(--btn-text, #fff)",
                  width: "20%",
                  height: "100%",
                  borderRadius: "10px",
                  border: "none",
                }}
                onClick={() => {
                  cardDashboardRef1.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>
          {["VIN"].includes(currentBlock["tag"]) && (
            <div
              ref={cardRef}
              id="display-card-vin"
              className="vin-popup-adaptive"
            >
              <div id="image-container" className="vin-popup-image">
                <img
                  alt=""
                  src={
                    Object.keys(config["single-image"]).includes(
                      "vin_popup_img",
                    )
                      ? config["single-image"]["vin_popup_img"]
                      : VINImg
                  }
                ></img>
              </div>
              <div id="btn-container" className="vin-popup-actions">
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    color: "var(--btn-text, #fff)",
                    borderRadius: "10px",
                    border: "none",
                  }}
                  onClick={() => {
                    cardRef.current.style.display = "none";
                    redLineVINcontainer.current.style.display = "flex";
                    startBtn.current.style.display = "block";
                  }}
                >
                  {Object.keys(config["single-image"]).includes("btnVinText")
                    ? config["single-image"]["btnVinText"]
                    : getTranslateText("Ok got it")}
                </button>
              </div>
            </div>
          )}
          {[
            "VIN",
            "Odometer",
            "Open Trunk",
            "Gear Shift",
            "Fuel tank",
          ].includes(currentBlock["tag"]) && (
              <div
                className="redLineVINcontainerView"
                style={{
                  height: ["porto_seguros", "client_1422_claim"].includes(clientId)
                    ? "90dvh"
                    : "100dvh",
                }}
                ref={redLineVINcontainer}
              >
                <div id="modalNameCont">
                  <p id="modalNameText">{currentBlock["id"]}</p>
                </div>
                <div
                  className="redLineVIN"
                  style={{
                    width: "70vw",
                    height:
                      currentBlock.tag === "VIN"
                        ? "40vh"
                        : ["porto_seguros", "client_1422_claim"].includes(clientId)
                          ? "47vh"
                          : "70vh",
                  }}
                ></div>
                <div id="guidanceText" style={{ width: "auto" }}>
                  <p
                    style={
                      ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { fontSize: "15px" }
                        : {}
                    }
                    ref={guidanceTextRef}
                    id="guidanceParaText"
                  ></p>
                </div>
              </div>
            )}
          {crateStencil && (
            <div ref={crateStencilRef} className="crate-stencil-overlay">
              <svg
                className="crate-stencil-svg"
                viewBox={crateStencil.viewBox}
                preserveAspectRatio="xMidYMid meet"
              >
                {crateStencil.paths.map((d) => (
                  <path key={d} d={d} vectorEffect="non-scaling-stroke" />
                ))}
              </svg>
            </div>
          )}
          <div
            ref={startBtn}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
            onClick={captureImg}
            id="btn-vin-start"
          ></div>
          <div ref={backRef} className="back-btn">
            <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
          </div>
          {Object.keys(currentBlock).includes("cameraInstruction") && (
            <div className="camerInst">
              <p>{currentBlock["cameraInstruction"]}</p>
            </div>
          )}
          <div
            id="vin-image"
            className="single-image-fullscreen"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
            ref={imgRef}
          >
            <div id="display-card-success-top" ref={feedbackSuccessTopPopRef}>
              <div className="success-section">
                <div className="success-icon-wrapper">
                  <Check className="success-icon" strokeWidth={3} />
                </div>
                <div className="success-text-wrapper">
                  <h1 className="success-title">
                    {currentBlock["tag"] === "Engine" ||
                      currentBlock["tag"] === "RC"
                      ? getTranslateText(
                        currentBlock["tag"] === "RC"
                          ? "Document validated successfully!"
                          : "Engine detected successfully!",
                      )
                      : clientId === "client_1827" || clientId === "client_1827_prod"
                        ? "Broj šasije je uspješno prepoznat!"
                        : getTranslateText("# Detected Successfully!").replace(
                          "#",
                          currentBlock["id"],
                        )}
                  </h1>
                  {Object.keys(config).includes("allowVinFeedbackEdit") &&
                    config["allowVinFeedbackEdit"] && (
                      <p className="success-subtitle">
                        {getTranslateText(
                          "Please verify the information detected below.",
                        )}
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div ref={feedBackPopUp} id="display-card-zizo">
              <div
                ref={headerText1}
                id="zizo-loader-text"
                style={{
                  textAlign: "center",
                  display: "block",
                  padding: "5dvh 1dvh 5dvh 1dvh",
                }}
              >
                <h3 style={{ margin: "0px" }} ref={feedBackPopText}></h3>
              </div>
              <div
                ref={imageRef}
                id="zizo-loader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  ref={carInspectionRef}
                  src={car_inspection}
                  alt="123"
                  style={{
                    zIndex: 5,
                    width: "17dvw",
                    height: "unset",
                    borderRadius: "2%",
                    padding: "0px 0px 2dvh 0px",
                  }}
                />
              </div>
              <div
                ref={feedbackBtnRef}
                style={{
                  display: "none",
                  padding: "0px 0px 2dvh 0px",
                  width: "100%",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  className="feedbackbtn"
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    fontSize: "medium",
                  }}
                  onClick={() => {
                    feedBackPopUp.current.style.display = "none";
                    crossTickBtn.current.style.display = "block";
                    ++vinCapturedCount;
                    imageRetake();
                  }}
                >
                  {feedbackBtnText}
                </button>
              </div>
            </div>
            <div
              id="display-card-success-bottom"
              ref={feedbackSuccessBottomPopRef}
            >
              {/* --- 2. VIN Display/Edit Section --- */}
              <div id="vin-edit-section">
                <label
                  style={{
                    color: "#ffffffde",
                    fontSize: "13px",
                    fontWeight: "600",
                    margin: "0px",
                    padding: "5px 0px 5px 5px",
                  }}
                >
                  {getTranslateText("Detected #:").replace(
                    "#",
                    currentBlock["id"],
                  )}
                </label>

                {isEditing ? (
                  <>
                    <input
                      type="text"
                      value={message}
                      onChange={handleVinChange}
                      onBlur={() => {
                        setMessage(formatVinForDisplay(message));
                        setIsEditing(false);
                        if (vinEditToastId) {
                          toast.dismiss(vinEditToastId); // Dismiss any lingering toast
                          vinEditToastId = null;
                        }
                      }}
                      autoFocus
                      id="vin-input"
                      ref={vinInputRef}
                    />
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      paddingLeft: "5px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: "800",
                        color: "white",
                        letterSpacing: "1px",
                      }}
                    >
                      {formatVinForDisplay(message)}
                    </span>
                  </div>
                )}
                {Object.keys(config).includes("allowVinFeedbackEdit") &&
                  config["allowVinFeedbackEdit"] && (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                          width: "5dvw",
                          height: "6dvh",
                        }}
                      >
                        <div
                          onClick={() => setIsEditing(true)}
                          className="icon-btn"
                        >
                          <SafeImage
                            src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/edit-icon.png"
                            alt="123"
                            style={{
                              width: "3.5dvw",
                              objectFit: "unset",
                              height: "unset",
                            }}
                            fallback={null}
                          />
                        </div>
                      </div>
                      <div className="input-footer">
                        <span className="input-status">
                          {isEditing
                            ? getTranslateText("Editing enabled")
                            : getTranslateText("Tap edit icon to modify")}
                        </span>
                      </div>
                    </>
                  )}
              </div>
              {Object.keys(config).includes("allowVinFeedbackEdit") &&
                config["allowVinFeedbackEdit"] && (
                  <div
                    style={{
                      display: "flex",
                      padding: "0px 0px 2dvh 0px",
                      alignContent: "center",
                      justifyContent: "center",
                      width: "180px",
                      borderRadius: "5px",
                    }}
                  >
                    <button
                      className="feedbackbtn"
                      style={{
                        backgroundColor: config["colors"]["btn"],
                        fontSize: "medium",
                      }}
                      onClick={() => {
                        if (message.length < 17) {
                          toast.error(
                            getTranslateText(
                              "# must be 17 characters long.",
                            ).replace("#", currentBlock["id"]),
                            {
                              theme: "colored",
                            },
                          );
                          return;
                        }
                        feedbackSuccessTopPopRef.current.style.display = "none";
                        feedbackSuccessBottomPopRef.current.style.display =
                          "none";
                        imageNext();
                      }}
                    >
                      {feedbackBtnText}
                    </button>
                  </div>
                )}
            </div>
            <img
              ref={divImgRef}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            />
            <div ref={crossTickBtn} className="cross-tick-btn">
              {
                getNewConfirmBtn() ? (
                  <>
                    <div style={{ position: "absolute", display: "flex", width: "100%", alignItems: "center", justifyContent: "center", alignContent: "center", top: "10%" }}>
                      <div id="modalNameCont" style={{ fontSize: "16px" }}>
                        <p id="modalNameText">{currentBlock["id"] + " (" + getTranslateText("Preview") + ")"}</p>
                      </div>
                    </div>
                    <button
                      className="new-retake-btn"
                      style={{ backgroundColor: config["colors"]["crossBtn"] ? config["colors"]["crossBtn"] : "#FF8C00" }}
                      onClick={imageRetake}
                    >
                      <i className="fas fa-undo"></i>
                      {getTranslateText("Recapture")}
                    </button>
                    <button
                      className="new-next-btn"
                      style={{ backgroundColor: config["colors"]["btn"] }}
                      onClick={() => {
                        if (
                          getVinFeedback() &&
                          ![
                            "client_1511",
                            "client_1298",
                            "client_1298_prod",
                            "client_1298_dev",
                          ].includes(clientId) &&
                          currentBlock["tag"] === "VIN" &&
                          vinCapturedCount === 0
                        ) {
                          vinCheckingHanlder();
                        } else if (
                          (currentBlock["tag"] === "Engine" ||
                            currentBlock["tag"] === "RC") &&
                          engineCapturedCount === 0
                        ) {
                          checkEngine = {};
                          engineCheckingHandler();
                        } else {
                          imageNext();
                        }
                      }}
                    >
                      <i className="fas fa-check"></i>
                      {getTranslateText("Done")}
                    </button>
                  </>
                ) : (
                  <>
                    <i
                      className="fas fa-times fa-2x vin-btn-retake"
                      onClick={imageRetake}
                    ></i>
                    <i
                      className="fas fa-check fa-2x vin-btn-next"
                      onClick={() => {
                        if (
                          getVinFeedback() &&
                          ![
                            "client_1511",
                            "client_1298",
                            "client_1298_prod",
                            "client_1298_dev",
                          ].includes(clientId) &&
                          currentBlock["tag"] === "VIN" &&
                          vinCapturedCount === 0
                        ) {
                          vinCheckingHanlder();
                        } else if (
                          (currentBlock["tag"] === "Engine" ||
                            currentBlock["tag"] === "RC") &&
                          engineCapturedCount === 0
                        ) {
                          checkEngine = {};
                          engineCheckingHandler();
                        } else {
                          imageNext();
                        }
                      }}
                    ></i>
                  </>
                )
              }
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default SingleImage;
